import {gql} from "@irati/utils/gql"
import RecognitionAutomationFragment from "../fragment/RecognitionAutomation"

export default gql`
  query RecognitionAutomation($uuid: ID!) {
    recognitionAutomation(uuid: $uuid) {
      ...RecognitionAutomation
    }
  }

  ${RecognitionAutomationFragment}
`
